import { Ziggy } from "../../Ziggy";
import type { CourseLeaf } from "../../../lib/learning/types";
import type { ZiggyAge, ZiggyPose } from "../../../lib/ziggy";
import { useLearnLocale } from "../../../lib/i18n/useLearnLocale";
import type { PortalStrings } from "../../../lib/i18n/usePortalLocale";
import type { RoadmapStep } from "./types";

function ziggyPoseForStep(step: RoadmapStep | null): ZiggyPose {
  if (!step) return "standing";
  if (step.status === "completed") return "excited";
  if (step.status === "current" || step.status === "available") return "cheerful";
  if (step.status === "locked") return "thinking";
  return "happy";
}

function coachLineForStep(step: RoadmapStep | null, s: PortalStrings): string {
  if (!step) return s.coachScrollForward;
  if (step.kind === "phase") {
    return s.coachEnteringPhase(step.title);
  }
  if (step.status === "completed") {
    return s.coachCheckpointCleared;
  }
  const leaf = step.meta?.leaf as CourseLeaf | undefined;
  if (step.status === "current" || step.status === "available") {
    if (leaf?.requires_step_quiz) {
      return s.coachQualifyStep;
    }
    return s.coachStepOpen;
  }
  return s.coachStepLocked;
}

export function RoadmapCoachStrip({
  focusStep,
  ziggyAge = "grown",
}: {
  focusStep: RoadmapStep | null;
  ziggyAge?: ZiggyAge;
}) {
  const { strings: s } = useLearnLocale();
  const pose = ziggyPoseForStep(focusStep);
  const line = coachLineForStep(focusStep, s);

  return (
    <div className="absolute inset-x-3 bottom-3 z-[120] flex items-end gap-2 sm:inset-x-4 sm:bottom-4">
      <Ziggy age={ziggyAge} pose={pose} size={56} glow alt="" className="shrink-0 sm:!h-[4.5rem]" />
      <div className="border-primary/20 from-background/95 to-background/90 mb-1 min-w-0 flex-1 rounded-2xl border bg-gradient-to-r px-3 py-2.5 shadow-lg backdrop-blur-md sm:px-4 sm:py-3">
        <p className="text-muted-foreground text-[0.6rem] font-semibold uppercase tracking-wide sm:text-[0.65rem]">
          {s.coachGuideLabel}
        </p>
        <p className="text-xs font-medium leading-snug sm:text-sm">{line}</p>
      </div>
    </div>
  );
}
